/**
 * Domain pack'larni bundle'ga olish: packs/<id>/... JSON fayllari Vite glob orqali
 * yig'ilib engine reyestrlariga beriladi (ilova mount bo'lishidan oldin).
 */
import { assemblePack, orderRawPacks, registerPack, type RawPack } from '@muslab/engine';

type Globbed = Record<string, unknown>;
const manifests = import.meta.glob('../../packs/*/pack.json', { eager: true, import: 'default' }) as Globbed;
const singles = import.meta.glob('../../packs/*/components.json', { eager: true, import: 'default' }) as Globbed;
const components = import.meta.glob('../../packs/*/components/*.json', { eager: true, import: 'default' }) as Globbed;
const labs = import.meta.glob('../../packs/*/labs/*.json', { eager: true, import: 'default' }) as Globbed;
const reactions = import.meta.glob('../../packs/*/reactions.json', { eager: true, import: 'default' }) as Globbed;
const flowsheets = import.meta.glob('../../packs/*/flowsheets/*.json', { eager: true, import: 'default' }) as Globbed;
const i18n = import.meta.glob('../../packs/*/i18n/*.json', { eager: true, import: 'default' }) as Globbed;

const packOf = (path: string): string => path.match(/\/packs\/([^/]+)\//)?.[1] ?? '';
const collect = (g: Globbed, id: string): unknown[] =>
  Object.entries(g)
    .filter(([p]) => packOf(p) === id)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([, v]) => v);

export function registerAllPacks(): string[] {
  const raws: RawPack[] = [];
  for (const [path, manifest] of Object.entries(manifests)) {
    const id = packOf(path);
    const single = singles[`../../packs/${id}/components.json`];
    const raw: RawPack = {
      manifest,
      components: Array.isArray(single) ? (single as unknown[]) : collect(components, id),
      labs: collect(labs, id),
      reactions: Array.isArray(reactions[`../../packs/${id}/reactions.json`]) ? (reactions[`../../packs/${id}/reactions.json`] as unknown[]) : [],
      flowsheets: collect(flowsheets, id),
      i18n: Object.fromEntries(
        Object.entries(i18n)
          .filter(([p]) => packOf(p) === id)
          .map(([p, v]) => [p.replace(/.*\/([^/]+)\.json$/, '$1'), v as Record<string, string>]),
      ),
    };
    raws.push(raw);
  }
  const ids: string[] = [];
  for (const raw of orderRawPacks(raws)) {
    const pack = assemblePack(raw);
    registerPack(pack);
    ids.push(pack.manifest.id);
  }
  return ids;
}
